<template lang="pug">
.batch-export
  el-button.bgc-f(type="danger" plain size="small" @click="showBatchExportDialog")  批量导入商品
  el-dialog(title="批量导入商品" :visible.sync="isShowExportGoods" center append-to-body width="780px")
    el-form(label-width="120px" :model="exportData")
      el-form-item.mb-15(label="规格：" :rules="[ { required: true } ]")
        el-radio(v-model="exportData.subItemType" label="NORMAL") 明确规格商品
        el-radio(v-model="exportData.subItemType" label="UNCERTAIN") 不定规格商品
      el-form-item.mb-15(label="类目名：" :rules="[ { required: true } ]")
        el-select(v-model="exportData.secondCategoryName" placeholder="选择类目名")
          el-option(v-for="item, index in exportGoodsCategories" :key="index" :label="item.name" :value="item.name")
        el-button.bgc-f.ml-20(type="danger" plain @click="downloadTemplate" size="small") 下载模版
      el-form-item.mb-15(label="上传文件：" :rules="[ { required: true } ]")
        el-upload(:action="UPLOAD_ROOT" :on-success="handleSuccess" :data="uploadData"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" v-if="isShowExportGoods"
          :on-remove="handleRemove" :multiple="false" :file-list="fileList"
          :before-upload="beforeUpload")
          el-button(size="small" type="primary") 点击上传
          .tip(slot="tip") 请按照胖猫模板导入商品
          .tip.red(slot="tip") 新模板上线啦：新增预售现货字段，请重新下载模板上传商品，如果不填写商品销售类型，则默认为现货。
      el-form-item.mb-15(label="批量自动加价：")
        el-input(v-model="exportData.batchAddPrice" @input="priceInput" style='width: 200px')
          template(slot="append") 元
        .tip.red.discount(v-if="promotion.reductionAmount > 0") 提示：您有针对会员的优惠减免：-{{ promotion.reductionAmount / 100 }}元/吨
          a(@click="viewEquity") 查看会员权益>>
        .tip.red 系统自动在您上传的价格上加价，普通用户只能看到加价后的价格
      el-form-item.mb-15(label="商品状态：")
        el-radio-group(v-model="exportData.defaultStatus")
          el-radio(:label="2") 上 架
          el-radio(:label="1") 待 售
      el-form-item(label="物流配送：")
        freight-set(
          ref="freight-set"
          :freight-id="exportData.transportTemplateId"
          :is-show-new-btn="false"
          @change="onChangeTransportTemplate"
        )
      el-form-item(label=" " )
        goods-release-rule(v-model="isArrageRlue")

    .dialog-footer(slot="footer")
      el-button(@click="isShowExportGoods = false") 取 消
      el-button(type="primary" @click="conformExportGoods" :disabled="!isArrageRlue") 确 认
</template>

<script>
import { UPLOAD_ROOT, FILE_ROOT, ZM_ROOT } from '@/common/constants/'
import { getWebToken } from '@/common/utils/common'
import freightSet from '@/components/form/freightSet'
import GoodsReleaseRule from '@/components/goodsReleaseRule'
import open from '@/common/utils/open'
export default {
  name: 'ListSearch',
  data() {
    return {
      isShowExportGoods: false,
      exportGoodsCategories: [],
      exportData: {
        subItemType: 'NORMAL',
        secondCategoryName: '',
        defaultStatus: 2,
        transportTemplateId: 0,
        batchAddPrice: ''
      },
      UPLOAD_ROOT,
      fileList: [],
      uploadData: {
        _fs: 1,
        _tk: getWebToken(),
        _aid: 24
      },
      loopInterval: 0,
      loopCount: 0,
      isArrageRlue: true,
      promotion: {}
    }
  },
  components: {
    freightSet,
    GoodsReleaseRule
  },
  methods: {
    viewEquity() {
      open('/shop/member/equity/list')
    },
    showBatchExportDialog() {
      this.getMemberPromotion()
      this.getCategoryTree()
      this.isShowExportGoods = true
      this.exportData.fileName = ''
      this.exportData.fileKey = ''
      this.exportData.transportTemplateId = 0
      this.fileList = []
      this.exportGoodsCategories = []
    },
    /** 获取类目列表*/
    async getCategoryTree() {
      try {
        const result = await this.$post('items.getCategoryTree')
        if (result.success) {
          result.data[0] &&
            result.data[0].children.forEach(item => {
              delete item.children
              this.exportGoodsCategories.push(item)
            })
          this.exportData.secondCategoryName =
            this.exportData.secondCategoryName || this.exportGoodsCategories[0].name
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 上传成功 */
    handleSuccess(response, file, fileList) {
      if (response.status == 806) {
        this.$message.warning('长时间未操作，请重新登录')
        setTimeout(() => {
          this.$store.dispatch('user/logout')
          this.$store.dispatch('tagsView/delAllViews')
          window.IM && window.IM.destroy()
        }, 1000)
        return
      }
      this.exportData.fileName = file.name
      this.exportData.fileKey = file.response.data || response.data
      this.fileList = [
        {
          name: file.name
        }
      ]
    },
    /** 删除成功 */
    handleRemove() {
      this.exportData.fileName = ''
      this.exportData.fileKey = ''
    },
    beforeUpload(file, fileList) {
      const isXls =
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'application/vnd.ms-excel' ||
        !file.type
      if (!isXls) {
        this.$message.error('上传文件只能是excel!')
        return false
      }
      this.uploadData._tk = getWebToken()
      return isXls
    },
    /** 确认上传商品的excel */
    async conformExportGoods() {
      if (!this.exportData.subItemType) {
        return this.$message.error('请选择规格')
      }
      if (!this.exportData.fileKey) {
        return this.$message.error('请上传文件后在导入')
      }
      if (!this.exportData.transportTemplateId) {
        const isChecked = this.$refs['freight-set'].getIsChecked()
        if (isChecked) {
          return this.$message.error('请选择运费模版')
        }
      }
      try {
        const data = { ...this.exportData }
        data.batchAddPrice = data.batchAddPrice * 100
        const result = await this.$get('items.uploadAndParseExcelSku', {
          ...data
        })
        if (result.success) {
          if (result.data[0].isSuccess) {
            this.isShowExportGoods = false
            this.uplaodFileId = result.data[0].id
            this.loading = this.$loading({
              lock: true,
              text: '商品上传中',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            this.loopInterval = window.setInterval(() => {
              this.loopCount++
              this.loopGoodsUploadResult()
            }, 500)
          } else {
            this.$message.error(result.data[0].msg || '商品导入失败')
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 下载商品的excel模版 */
    async downloadTemplate() {
      try {
        const result = await this.$get('items.getExcelFileTemplate', {
          secondCategoryName: this.exportData.secondCategoryName
        })
        if (result.success) {
          if (result.data[0].value) {
            let downloadElement = document.createElement('a')
            downloadElement.href = `${FILE_ROOT}${result.data[0].value}`
            document.body.appendChild(downloadElement)
            downloadElement.click()
            window.URL.revokeObjectURL(`${FILE_ROOT}${result.data[0].value}`)
            document.body.removeChild(downloadElement)
          } else {
            this.$message.error('获取模版信息失败')
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 轮循商品上传结果 */
    async loopGoodsUploadResult() {
      try {
        const result = await this.$post('items.queryExcelSkuFileVOById', {
          id: this.uplaodFileId
        })
        if (result.success) {
          if (this.loopCount >= 60) {
            clearInterval(this.loopInterval)
            this.loopCount = 0
            this.loading.close()
            this.$message.success('商品上传成功，刷新页面查询！')
          } else if (result.data[0].status > 2) {
            const content = result.data[0]
            if (content.status === 3) {
              this.$message.error('解析完成，处理结果文件失败')
            } else {
              let tipText =
                content.status === 5
                  ? `上传${content.successNum + content.failedNum}条数据，成功${
                      content.successNum
                    }条，失败${content.failedNum}条`
                  : `${content.remark}`
              this.$alert(
                `<div><div style="margin-bottom: 5px">${tipText}</div><div>请前去导入记录下载失败文件。</div></div>`,
                content.status === 5 ? '上传成功' : '上传失败',
                {
                  center: true,
                  confirmButtonText: '确认',
                  dangerouslyUseHTMLString: true
                }
              ).then(() => {
                this.$msgbox.close()
              })
            }
            clearInterval(this.loopInterval)
            this.loopCount = 0
            this.loading.close()
            console.log(content.status)
            if (content.status === 5) {
              this.$emit('loopSuccess')
            }
          }
        } else {
          clearInterval(this.loopInterval)
          this.loopCount = 0
          this.loading.close()
          this.$message.success('商品上传成功，刷新页面查询！')
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 修改运费模版
    onChangeTransportTemplate(id) {
      this.exportData.transportTemplateId = id
    },
    async getDefaultCategoryAndBatchPrice() {
      let { success, data } = await this.$get('items.getDefaultCategoryAndBatchPrice')
      if (success && data[0]) {
        const batchAddPrice = data[0].batchAddPrice
        const reductionAmount = this.promotion.reductionAmount
        const priceFlag = typeof batchAddPrice === 'number'
        const amountFlag = typeof reductionAmount === 'number'
        this.exportData.batchAddPrice =
          !amountFlag && !reductionAmount
            ? ''
            : !priceFlag
            ? reductionAmount / 100
            : batchAddPrice / 100
        this.exportData.secondCategoryName = data[0].secondCategoryName || '冷镀'
      }
    },
    priceInput(value, item) {
      value = value.replace(/[^0-9]+/g, '')
      // value = value === '' ? 0 : value
      value = value > 100 ? 100 : value
      this.exportData.batchAddPrice = value
    },
    async getMemberPromotion() {
      let { success, data } = await this.$get('promotion.getMemberPromotion')
      if (success && data[0]) {
        this.promotion = data[0]
      }
      this.getDefaultCategoryAndBatchPrice()
    }
  }
}
</script>

<style lang="stylus" scoped>
.batch-export
  .bgc-f
    background #fff
    background-color #fff
    &:focus
      color #ff4949
    &:hover
      color #fff
      background-color #ff4949
.discount.tip a{
    color red
    margin-left 5px
    &:hover{
      color #cd974c
    }
  }
.tip
  height 25px
  line-height 25px
  font-size 12px
  color #9e9e9e
.red
  color #F56C6C
.mb-15
  margin-bottom 15px

.ml-20
  margin-left 20px
</style>
